import React, { useState, useEffect, useRef } from 'react';
import { SubscriptionPlanService } from "../services/SubscriptionPlanService";
import classNames from 'classnames';
import { TagService } from "../../../service/TagService";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService, MANAGE_SUBSCRIPTIONPLANS } from '../../../service/AuthorizationService';
import '../../../components/Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import { Paginator } from 'primereact/paginator';
import { PickList } from 'primereact/picklist';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton';
import { LanguageService } from '../../../service/LanguageService';
import { InputNumber } from 'primereact/inputnumber';
import { FileService } from '../../../service/FileService';
import { Editor } from 'primereact/editor';


export default function SubscriptionPlanCrud() {

    const authorizationService = new AuthorizationService();
    const service = new SubscriptionPlanService();
    const languageService = new LanguageService();
    const tagService = new TagService();

    const client = authorizationService.getCurrentUser().client || {};

    let emptyObject = {
        id: uuidv4(),
        name: '',
        client_id: client.id,
        config: {}
    };

    const [list, setList] = useState(null);
    const [itemDialog, setItemDialog] = useState(false);
    const [deleteItemDialog, setDeleteItemDialog] = useState(false);
    const [tags, setTags] = useState([]);
    const [item, setItem] = useState(emptyObject);
    const [selectedItems, setSelectedItems] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [hasAccess, setHasAccess] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState("config->>'order'");
    const [sortOrder, setSortOrder] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [searching, setSearching] = useState(false);

    const updateList = async () => {
        setSearching(true);
        const data = await service.list(first, rowsPerPage, search, sortField, sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords);
        setSearching(false);
    }

    const onPageChange = async (pageEvent) => {
        setSearching(true);
        setFirst(pageEvent.first);
        setRowsPerPage(pageEvent.rows);
        const data = await service.list(pageEvent.first, pageEvent.rows, search, sortField, sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    const doSearch = async (reset) => {
        setSearching(true);
        const data = await service.list(first, rowsPerPage, reset ? null : globalFilter, sortField, sortOrder);
        setSearch(globalFilter);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    const onSort = async (sortEvent) => {
        setSearching(true);
        setSortField(sortEvent.sortField);
        setSortOrder(sortEvent.sortOrder);
        const data = await service.list(first, rowsPerPage, search, sortEvent.sortField, sortEvent.sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    useEffect(() => {
        setHasAccess(authorizationService.hasPermission(MANAGE_SUBSCRIPTIONPLANS));

        if(authorizationService.hasPermission(MANAGE_SUBSCRIPTIONPLANS)){
            async function fetchData() {
                await updateList();

                const tagsData = await tagService.listAll();
                setTags(tagsData);
                
                setLoading(false);
            }        
            fetchData();
            
        }
    }, []);

    const saveDisabled = () => {
        return (item.name || "") === "" ||
        (item.config.description || "") === "";
    }

    const openNew = async () => {
        try {
            setModalLoading(true);
            emptyObject.id = uuidv4();
            setItem(emptyObject);
            setSubmitted(false);
            setItemDialog(true);
            setModalLoading(false);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setModalLoading(false);
            console.log(error);
            throw error;
        }
        
        
    }

    const hideDialog = () => {
        if(!saving){
            setSubmitted(false);
            setItemDialog(false);
        }
    }

    const isDataValid = () => {

        if((item.name || "") === ""){
            toast.current.show({ severity: 'error', summary: 'Dados Inválidos', detail: 'Por favor preencha o campo "Nome"', life: 3000 });
            return false;
        }
        else if(((item.config || {}).has_expiration) && (((item.config || {}).expiration_in_months || "") === "")){
            toast.current.show({ severity: 'error', summary: 'Dados Inválidos', detail: 'Por favor preencha o campo "Prazo"', life: 3000 });
            return false;
        }

        return true;
    }

    const saveItem = async () => {
        try {
            setSaving(true);
            setSubmitted(true);

            if (isDataValid()) {
                item.client_id = client.id;
                delete item.files;
                if (item.id) {
                    await service.update(item);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Item Updated', life: 3000 });
                }
                else {
                    await service.create(item);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Item Created', life: 3000 });
                }

                await updateList();
                setItemDialog(false);
                setItem(emptyObject);
                setSaving(false);
            }
            else {
                setSaving(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
            console.log(error);
            throw error;
        }
    }

    const editItem = async (item) => {
        try{
            setModalLoading(true);
            const fileService = new FileService();
            const files = await fileService.listByEntity("subscriptionplan", item.id);
            setItem({ ...Object.assign(item, { files }) });
            setItemDialog(true);
            setModalLoading(false);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setModalLoading(false);
            console.log(error);
            throw error;
        }
    }

    const confirmDeleteItem = (item) => {
        setItem(item);
        setDeleteItemDialog(true);
    }

    const deleteItem = async () => {
        try {
            setSaving(true);
            await service.delete(item);
            await updateList();
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Item Deleted', life: 3000 });    
        } catch (error) {
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });    
            setSaving(false);
        }

        setDeleteItemDialog(false);
        setItem(emptyObject);
        setSaving(false);
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        onInputValueChange(name, val);
    }

    const onInputValueChange = (name, val) => {
        let _item = { ...item };
        _.set(_item, name, val);
        setItem(_item);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label={languageService.getText("New")} icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editItem(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteItem(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">{languageService.getText("Manage_SubscriptionsPlans")}</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => {setGlobalFilter(e.target.value); if(e.target.value === "") doSearch(true);}} placeholder={languageService.getText("Search") + "..."}  onKeyDown={(e) => { if (e.key === 'Enter') { doSearch()}}}/>
            </span>
        </div>
    );

    const itemDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("Cancel")} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            { !saving && <Button label={languageService.getText("Save")} icon="pi pi-check" className="p-button-text" onClick={saveItem} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );

    const deleteItemDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("No")} icon="pi pi-times" className="p-button-text" onClick={() => setDeleteItemDialog(false)} />}
            { !saving && <Button label={languageService.getText("Yes")} icon="pi pi-check" className="p-button-text" onClick={deleteItem} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );
    
    const onChangeTagValues = (e, tagId) => {
        if(!item.config.tag_values){
            item.config.tag_values = [];
        }

        item.config.tag_values = item.config.tag_values.filter(v => v.tag_id !== tagId).concat(e.target);

        setItem(Object.assign({}, item));
    }

    const uploadFromFile = async (e) => {
        if(e.target.files && e.target.files[0]){
            setSaving(true);
            setUploading(true);
            const reader = new FileReader();
            reader.addEventListener("load", async () => {
                try {
                    const fileService = new FileService();
                    const file = await fileService.upload("subscriptionplan", item.id, "thumbnail", reader.result);
                    const files = await fileService.listByEntity("subscriptionplan", item.id);
                    
                    let _item = { ...item };
                    
                    _.set(_item, 'config.thumbnail', file.id);
                    _item.files = files;

                    setItem(_item);
                    setSaving(false);
                    setUploading(false);
                } catch (error) {
                    setSaving(false);
                    setUploading(false);
                    toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });  
                }

                
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const uploadNewImageFromFile = async (e) => {
        if(e.target.files && e.target.files[0]){
            setSaving(true);
            setUploading(true);
            const reader = new FileReader();
            reader.addEventListener("load", async () => {
                try {
                    const fileService = new FileService();
                    const file = await fileService.upload("subscriptionplan", item.id, "images_" + (new Date()).getTime(), reader.result);
                    const files = await fileService.listByEntity("subscriptionplan", item.id);
                    
                    let _item = { ...item };

                    const images = item.config.images || [];
                    images.push(file.id);
                    _.set(_item, 'config.images', images);
                    _item.files = files;

                    setItem(_item);
                    setSaving(false);
                    setUploading(false);
                } catch (error) {
                    setSaving(false);
                    setUploading(false);
                    toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });  
                }

                
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const deleteImage = async (id) => {
            setSaving(true);
            setUploading(true);
            try {
                console.log(id)
                let _item = { ...item };
                const images = (item.config.images || []).filter(f => f !== id);
                _.set(_item, 'config.images', images);
                setItem(_item);
                setSaving(false);
                setUploading(false);
            } catch (error) {
                setSaving(false);
                setUploading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });  
            }
    }

    if(hasAccess){

        return (
            <>
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { loading && <ProgressBar mode="indeterminate"/> }
                    { !loading && <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>}
                    
                    { !loading &&
                    <>
                    <DataTable ref={dt} value={list} selection={selectedItems} onSelectionChange={(e) => setSelectedItems(e.value)}
                        dataKey="id" rows={rowsPerPage} rowsPerPageOptions={[5, 10, 25]}
                        header={header}
                        autoLayout={true}
                        onSort={onSort}
                        sortField={sortField} 
                        sortOrder={sortOrder}
                        loading={searching}
                        >

                        <Column field="name" header={languageService.getText("Name")}></Column>
                        <Column field="config.setup_fee.price" header={languageService.getText("Pagamento Inicial")} body={(row) => ((row.config.setup_fee) || {}).active ? parseFloat("" + ((row.config.setup_fee) || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'}) : "-"} style={{textAlign: 'right'}}></Column>
                        <Column field="config.recurring_fee.price" header={languageService.getText("Pagamento Recorrente")} body={(row) => ((row.config.recurring_fee) || {}).active ? parseFloat("" + ((row.config.recurring_fee) || {}).price).toLocaleString('pt-BR',{minimumFractionDigits: 2, style: 'currency', currency: 'BRL'}) : "-"} style={{textAlign: 'right'}}></Column>
                        <Column field="config.expiration_in_months" header={languageService.getText("Prazo")} body={(row) => row.config.has_expiration ? row.config.expiration_in_months + " " + languageService.getText("months") : "Sem prazo"}></Column>
                        <Column field="config.disabled" header={languageService.getText("Ativo")} body={(row) => row.config.disabled ? languageService.getText("No") : languageService.getText("Sim")} style={{textAlign: 'center'}}></Column>
                        <Column field="config.external_checkout" header={languageService.getText("Checkout Externo")} body={(row) => row.config.external_checkout ? languageService.getText("Yes") : languageService.getText("No")} style={{textAlign: 'center'}}></Column>
                        <Column field="config->>'order'" sortable header={languageService.getText("Ordenação")} body={(row) => row.config.order ? row.config.order : "-"} style={{textAlign: 'center'}}></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>
                    <Paginator first={first} rows={rowsPerPage} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 50, 100]} onPageChange={onPageChange}></Paginator>
                    </>
                    }
                </div>

                <Dialog visible={itemDialog} style={{ width: '60vw' }} header={languageService.getText("Item_Details")}s modal className="p-fluid" footer={itemDialogFooter} onHide={hideDialog}>

                    <Fieldset legend={languageService.getText("BasicInfo")}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12">
                                <label htmlFor="name">{languageService.getText("Name")}</label>
                                <InputText disabled={saving} id="name" value={item.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !item.name })} />
                                {submitted && !item.name && <small className="p-invalid">{languageService.getText("Name")} é obrigatório.</small>}
                            </div>
                            <div className="p-field p-col-12">
                                <label htmlFor="code">{languageService.getText("Código")} (max. 20)</label>
                                <InputText disabled={saving} id="code" value={item.config.code} maxLength={20} onChange={(e) => onInputChange(e, 'config.code')} />
                            </div>
                            <div className="p-field p-col-12">
                                <label htmlFor="description">{languageService.getText("Texto de Destaque")}</label>
                                <Editor disabled={saving} id="summary" style={{height:'100px'}} value={item.config.summary} onTextChange={(e) => onInputValueChange('config.summary', e.htmlValue)} />
                            </div>
                            <div className="p-field p-col-12">
                                <label htmlFor="description">{languageService.getText("Descrição Completa")}</label>
                                <Editor disabled={saving} id="description" style={{height:'320px'}} value={item.config.description} onTextChange={(e) => onInputValueChange('config.description', e.htmlValue)} />
                            </div>
                            <div className="p-field p-col-4">
                                <label htmlFor="name">Ativo</label>
                                <ToggleButton 
                                    checked={!(item.config || {}).disabled} 
                                    onChange={(e) => onInputValueChange('config.disabled', !e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            <div className="p-field p-col-8">
                                <label htmlFor="order">{languageService.getText("Ordenação")}</label>
                                <InputNumber disabled={saving} id="order" value={item.config.order} onValueChange={(e) => onInputValueChange('config.order', e.value)}/>
                            </div>
                            <div className="p-field p-col-4">
                                <label htmlFor="name">Checkout Externo</label>
                                <ToggleButton 
                                    checked={(item.config || {}).external_checkout} 
                                    onChange={(e) => onInputValueChange('config.external_checkout', e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            <div className="p-field p-col-8">
                                { (item.config || {}).external_checkout && <>
                                <label htmlFor="code">{languageService.getText("URL")}</label>
                                <InputText disabled={saving} id="external_checkout_url" value={item.config.external_checkout_url} onChange={(e) => onInputChange(e, 'config.external_checkout_url')} />
                                </>}
                            </div>
                        </div>
                        
                    </Fieldset>

                    <Fieldset legend={languageService.getText("Prazo")}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-3">
                                <label htmlFor="name">Prazo determinado?</label>
                                <ToggleButton 
                                    checked={(item.config || {}).has_expiration} 
                                    onChange={(e) => onInputValueChange('config.has_expiration', e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            { (item.config || {}).has_expiration &&
                            <div className="p-field p-col-3">
                                <label htmlFor="expiration">{languageService.getText("Expiration")}</label>
                                <InputNumber disabled={saving} id="expiration" value={item.config.expiration_in_months} onValueChange={(e) => onInputValueChange('config.expiration_in_months', e.value)} suffix={" " + languageService.getText("months")} className={classNames({ 'p-invalid': submitted && (((item.config || {}).has_expiration) && (((item.config || {}).expiration_in_months || "") === "")) })}/>
                                {submitted && (((item.config || {}).has_expiration) && (((item.config || {}).expiration_in_months || "") === "")) && <small className="p-invalid">{languageService.getText("Expiration")} é obrigatório.</small>}
                            </div>}
                        </div>
                    </Fieldset>

                    <Fieldset legend={languageService.getText("Pagamento Inicial (Setup Fee)")}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-3">
                                <label htmlFor="name">{languageService.getText("Active")}</label>
                                <ToggleButton 
                                    checked={(item.config.setup_fee || {}).active} 
                                    onChange={(e) => onInputValueChange('config.setup_fee.active', e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            { (item.config.setup_fee || {}).active && <>
                                <div className="p-field p-col-3">
                                    <label htmlFor="setupfee_label">{languageService.getText("Label")}</label>
                                    <InputText disabled={saving} id="setupfee_label" value={(item.config.setup_fee || {}).label} onChange={(e) => onInputChange(e, 'config.setup_fee.label')}/>
                                </div>
                                <div className="p-field p-col-3">
                                    <label htmlFor="setupfee_price">{languageService.getText("Price")}</label>
                                    <InputNumber disabled={saving} id="setupfee_price" value={(item.config.setup_fee || {}).price} onValueChange={(e) => onInputValueChange('config.setup_fee.price', e.value)} mode="currency" currency="BRL" locale="pt-BR"/>
                                </div>
                            </>}
                        </div>
                    </Fieldset>

                    <Fieldset legend={languageService.getText("Pagamentos Recorrentes")}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-3">
                                <label htmlFor="name">{languageService.getText("Active")}</label>
                                <ToggleButton 
                                    checked={(item.config.recurring_fee || {}).active} 
                                    onChange={(e) => onInputValueChange('config.recurring_fee.active', e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            { (item.config.recurring_fee || {}).active && <>
                                <div className="p-field p-col-3">
                                    <label htmlFor="recurring_fee_label">{languageService.getText("Label")}</label>
                                    <InputText disabled={saving} id="recurring_fee_label" value={(item.config.recurring_fee || {}).label} onChange={(e) => onInputChange(e, 'config.recurring_fee.label')}/>
                                </div>
                                <div className="p-field p-col-3">
                                    <label htmlFor="recurring_fee_price">{languageService.getText("Price")}</label>
                                    <InputNumber disabled={saving} id="recurring_fee_price" value={(item.config.recurring_fee || {}).price} onValueChange={(e) => onInputValueChange('config.recurring_fee.price', e.value)} mode="currency" currency="BRL" locale="pt-BR"/>
                                </div>
                            </>}
                        </div>
                    </Fieldset>

                    <Fieldset legend={languageService.getText("Imagens e Vídeo")}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12">
                                <label htmlFor="code">{languageService.getText("Vídeo Youtube")} (ex.: https://www.youtube.com/embed/Ceavrs6qGPs)</label>
                                <InputText disabled={saving} id="video" value={item.config.video} onChange={(e) => onInputChange(e, 'config.video')} />                                
                            </div>
                            <div className="p-field p-col-12">
                                <label htmlFor="name">{languageService.getText("Thumbnail Vitrine")}:&nbsp;&nbsp;&nbsp;</label>
                                <input id="file" type="file" accept="image/*" onChange={uploadFromFile} style={{display: 'none'}}/>
                                <label htmlFor="file" >
                                    {!uploading && <span style={{ cursor: 'pointer'}}><i className="pi pi-fw pi-upload"></i></span> }
                                    {uploading && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                                </label>
                            </div>
                            { 
                                (item.config.thumbnail || "") !== "" &&
                                <div className="p-field p-col-12">
                                    <img src={((item.files || []).find(f => f.id === item.config.thumbnail) || {}).content} style={{maxHeight: '100px', maxWidth: '400px'}}/>
                                </div>
                            }
                            <div className="p-field p-col-12">
                                <label htmlFor="code">{languageService.getText("Mais Imagens")}</label>
                            </div>
                            <div className="p-field p-col-12 p-grid">
                                { (item.config.images || []).map(image =>
                                    <div className="p-field p-col-4" key={image}>
                                        <img src={((item.files || []).find(f => f.id === image) || {}).content} style={{maxHeight: '100px', maxWidth: '400px'}}/>
                                        <span style={{ cursor: 'pointer'}} onClick={() => deleteImage(image)}><i className="pi pi-fw pi-times"></i></span>
                                    </div>
                                )}
                            </div>
                            <div className="p-field p-col-12">
                                <input id="newImage" type="file" accept="image/*" onChange={uploadNewImageFromFile} style={{display: 'none'}}/>
                                <label htmlFor="newImage" >
                                    {!uploading && <span style={{ cursor: 'pointer'}}><i className="pi pi-fw pi-upload"></i></span> }
                                    {uploading && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                                </label>
                            </div>
                        </div>
                        
            
                    </Fieldset>
                    
                    { tags.map(tag =>
                        <Fieldset legend={tag.name} style={{marginTop: '10px'}} key={`tag_${tag.id}`}>
                        <div className="p-field">
                            <PickList 
                                source={tag.values.filter(v => !(item.config.tag_values || []).find(va => va.id === v.id))} 
                                target={tag.values.filter(v => (item.config.tag_values || []).filter(va => va.id === v.id).length > 0)} 
                                itemTemplate={(item) => <div>{item.name}</div>}
                                onChange={(e) => onChangeTagValues(e, tag.id)} 
                                sourceHeader={languageService.getText("Available")} targetHeader={languageService.getText("Selected")}
                                showSourceControls={false}
                                showTargetControls={false}
                            />
                        </div>    
                        </Fieldset>
                    )}
                    
                </Dialog>

                <Dialog visible={deleteItemDialog} style={{ width: '450px' }} header={languageService.getText("Confirm")} modal footer={deleteItemDialogFooter} onHide={() => setDeleteItemDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        {item && <span>{languageService.getText("Are_you_sure_you_want_to_delete")} <b>{item.name}</b>?</span>}
                    </div>
                </Dialog>

                

            </div>
            { modalLoading && <div style={{position: 'absolute', top: '0px', width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                    <ProgressSpinner strokeWidth="5"/>
                </div>
            }
            </>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>Permission Denied</b>
                </div>
            </div>
        );
    }
}